import styles from '@/components/static/StudyMaterialsGuidePage/StudyMaterialsGuidePage.module.scss'
import React, { ReactElement } from 'react'
import { BaseGuideComponent } from '@/components/static/StudyMaterialsGuidePage/GuideComponents/BaseGuideComponent/BaseGuideComponent'
import { GuideComponent } from '@/components/static/StudyMaterialsGuidePage/GuideComponents/GuideComponent.types'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import { reusableCssClass } from '@/utils/reusableCssClasses'
import { getAbbreviationName } from '@/components/static/StudyMaterialsGuidePage/utils'

export const Overview: React.FC<GuideComponent> = (props): ReactElement => {
    return (
        <BaseGuideComponent
            bulletSide={'right'}
            bullets={
                <div className={styles.bulletSection}>
                    <ol>
                        <li>
                            <div className={styles.header}>
                                Learn{' '}
                                <a
                                    href={
                                        UiLayoutConstant.STUDY_MATERIALS_GUIDE_NOTECARDS
                                    }
                                    className={reusableCssClass.clickableText}
                                >
                                    notecards
                                </a>
                            </div>
                            <div>Plan to spend most of your time here</div>
                        </li>
                        <li>
                            <div className={styles.header}>
                                Work{' '}
                                <a
                                    href={
                                        UiLayoutConstant.STUDY_MATERIALS_GUIDE_PROBLEMS
                                    }
                                    className={reusableCssClass.clickableText}
                                >
                                    practice questions
                                </a>
                            </div>
                            <div>
                                As you draw closer to the exam (1-2 months out)
                            </div>
                        </li>
                    </ol>
                </div>
            }
            nonBullet={
                <div className={styles.nonBulletSection}>
                    <div className={styles.title}>Overview</div>
                    <div className={styles.text}>
                        These are a series of recommendations for how we feel
                        &nbsp;{getAbbreviationName(props.courseConfigType)} can
                        best be used to optimize your study time. Naturally,
                        students learn best in different ways, so feel free to
                        use our product in whichever way fits you best. We are
                        constantly working to improve our product. Check out our{' '}
                        <a
                            href={UiLayoutConstant.UPDATES_PAGE}
                            className={reusableCssClass.clickableText}
                        >
                            platform updates page
                        </a>{' '}
                        for the latest information.
                    </div>
                </div>
            }
            shouldStackImagesAndBullets={props.shouldStackImagesAndBullets}
        />
    )
}
